import { render, staticRenderFns } from "./RagioneriaTipiContrattoView.vue?vue&type=template&id=33d114de&"
import script from "./RagioneriaTipiContrattoView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaTipiContrattoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports